global.prod = true;

if (window.location.hostname === 'petpass2.dev.v2.sk') {
    global.prod = false;
}

window.apiSchema = 'http';
if (prod) {
    window.apiSchema = 'https';
}

require('default-passive-events');
require('./bootstrap');
// require('livewire');
require('./timers');
// require('alpinejs');
require('./custom.v2');
require('select2');
require('jquery-timepicker/jquery.timepicker');

const Swal = window.Swal = require('sweetalert2');

import {Calendar} from '@fullcalendar/core';

window.Calendar = Calendar;
import bootstrapPlugin from '@fullcalendar/bootstrap';

window.bootstrapPlugin = bootstrapPlugin;
import dayGridPlugin from '@fullcalendar/daygrid';

window.dayGridPlugin = dayGridPlugin;
import interactionPlugin from '@fullcalendar/interaction';

window.interactionPlugin = interactionPlugin;
import listPlugin from '@fullcalendar/list';

window.listPlugin = listPlugin;
import timeGridPlugin from '@fullcalendar/timegrid';

window.timeGridPlugin = timeGridPlugin;

const Chart = window.Chart = require('chart.js/dist/chart');
